import { Editor } from 'slate'
import { string } from 'prop-types'
import { useContext } from 'react'
import { useSlateStatic } from 'slate-react'
import cc from 'classcat'

import { ToolbarContext } from '../RichTextEditor'

export default function MarkButton({ title, format }) {
  const editor = useSlateStatic()
  const [{ isLinkTooltipOpen, isColorPickerOpen, isButtonLinkTooltipOpen }] = useContext(ToolbarContext)

  const marks = Editor.marks(editor)
  const isActive = marks && marks[format]

  function handleMouseDown(event) {
    event.preventDefault()

    if (isActive) Editor.removeMark(editor, format)
    else Editor.addMark(editor, format, true)
  }

  return (
    <button
      className={cc([
        'dali-plugin-text-toolbar-button',
        `dali-plugin-text-toolbar-button-${format}`,
        { active: isActive },
      ])}
      data-command-name={format}
      type="button"
      title={title}
      disabled={!editor.selection && !isLinkTooltipOpen && !isColorPickerOpen && !isButtonLinkTooltipOpen}
      onMouseDown={handleMouseDown}
    />
  )
}

MarkButton.propTypes = { title: string.isRequired, format: string.isRequired }
